import { FtlRouteViewModel } from "../../ViewModel/FtlRouteViewModel";

export const getSpdrOnRouteById = (
  route: FtlRouteViewModel,
  spdrId: number
) => {
  return route.SpdrsOnThisRoute?.find((spdr) => spdr.SpdrId === spdrId);
};
